import distinguishedFolderId from 'owa-service/lib/factory/distinguishedFolderId';
import findPeopleJsonRequest from 'owa-service/lib/factory/findPeopleJsonRequest';
import findPeopleRequest from 'owa-service/lib/factory/findPeopleRequest';
import indexedPageView from 'owa-service/lib/factory/indexedPageView';
import personaResponseShape from 'owa-service/lib/factory/personaResponseShape';
import targetFolderId from 'owa-service/lib/factory/targetFolderId';
import findPeopleOperation from 'owa-service/lib/operation/findPeopleOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import contextProperty from 'owa-service/lib/factory/contextProperty';
var defaultPageView = {
    BasePoint: 'Beginning',
    Offset: 0,
    MaxEntriesReturned: 10,
};
var defaultShape = {
    BaseShape: 'Default',
};
function configureContext() {
    return [contextProperty({ Key: 'AppName', Value: 'OWA' })];
}
// Setting SearchPeopleSuggestionIndex to true will resolve the displayName correctly for non-contacts
function createFindPeopleRequest(queryString) {
    return findPeopleRequest({
        IndexedPageItemView: indexedPageView(defaultPageView),
        PersonaShape: personaResponseShape(defaultShape),
        QuerySources: ['Mailbox', 'Directory'],
        QueryString: queryString,
        SearchPeopleSuggestionIndex: true,
        ShouldResolveOneOffEmailAddress: true,
        Context: configureContext(),
    });
}
// Setting SearchPeopleSuggestionIndex to false will return also contacts
// Contacts will be searched in the root folder 'MyContacts'
function createFindContactsRequest(queryString) {
    return findPeopleRequest({
        IndexedPageItemView: indexedPageView(defaultPageView),
        PersonaShape: personaResponseShape(defaultShape),
        QuerySources: ['Mailbox'],
        QueryString: queryString,
        ParentFolderId: targetFolderId({
            BaseFolderId: distinguishedFolderId({
                Id: 'mycontacts',
            }),
        }),
        Context: configureContext(),
    });
}
function processResponseMessage(responseMessage, isContact) {
    if (responseMessage.ResponseClass == 'Success') {
        return { personas: responseMessage.ResultSet, requestId: responseMessage.TransactionId };
    }
    throw new Error("FindPeople failed (" + responseMessage.ResponseCode + " " + responseMessage.MessageText + " " + isContact + ")");
}
export function findPeopleByEmail(queryString) {
    return findPeopleOperation(findPeopleJsonRequest({
        Header: getJsonRequestHeader(),
        Body: createFindPeopleRequest(queryString),
    })).then(function (response) {
        return processResponseMessage(response.Body, false);
    });
}
export function findContactsByEmail(queryString) {
    return findPeopleOperation(findPeopleJsonRequest({
        Header: getJsonRequestHeader(),
        Body: createFindContactsRequest(queryString),
    })).then(function (response) {
        return processResponseMessage(response.Body, true);
    });
}
//# sourceMappingURL=findPeopleByEmail.js.map